import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { L as LoadingIcon } from '../LoadingIcon-I9FXQO9e.js';
import { i as invertedFocusOutline } from '../../theme/style-mixins/FocusIndicator/invertedFocusOutline-BxN_kWq6.js';
import { u as useSurface } from '../../SurfaceProvider/SurfaceProvider-qDGZSFCj.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const StyledLoadingIcon = /*#__PURE__*/styled(LoadingIcon).withConfig({
  componentId: "sc-storm-ui-40025937__sc-7di6d7-0"
})(["margin-inline-end:", ""], ({
  theme
}) => theme.button.padding.gap.base.default);
const StyledTextButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40025937__sc-7di6d7-1"
})(["font:", ";text-decoration:", ";background:none;border:none;border-radius:", ";padding:0;color:", ";user-select:auto;", ";", " :disabled{color:", ";cursor:not-allowed;:focus{outline:none;}:hover{text-decoration:", ";}}@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}", ""], ({
  size,
  theme
}) => theme.font.text[size].default, ({
  theme
}) => theme.link.decoration.default, ({
  theme
}) => theme.border.radius.medium, ({
  theme
}) => theme.link.color.default, ({
  $loading,
  theme
}) => $loading && css(["&&[aria-disabled=\"true\"]{cursor:not-allowed;color:", ";pointer-events:none;}"], theme.text.color.unavailable), ({
  theme,
  $variant
}) => {
  if ($variant === 'inverted') {
    return css(["color:", ";text-decoration:", ";:hover{color:", ";text-decoration:", ";background:none;cursor:pointer;}:active{color:", ";}:focus-visible{", "}"], theme.link.color.inverted, theme.link.decoration.hover, theme.link.color.invertedHover, theme.link.decoration.hover, theme.link.color.invertedHover, invertedFocusOutline);
  }
  return css(["color:", ";text-decoration:", ";:hover{color:", ";text-decoration:", ";background:none;cursor:pointer;}:focus-visible{", "}"], theme.link.color.default, theme.link.decoration.default, theme.link.color.hover, theme.link.decoration.hover, focusOutline);
}, ({
  theme
}) => theme.text.color.unavailable, ({
  theme
}) => theme.link.decoration.default, isMobile(css(["font:", ";"], ({
  size,
  theme
}) => theme.font.text[size].mobile)));
const TextButton = ({
  buttonRef,
  children,
  disabled = false,
  loading = false,
  loadingLabel,
  onClick,
  size = 'base',
  taktId,
  taktValue,
  type = 'button',
  variant = 'default',
  ...rest
}) => {
  const {
    isInverted
  } = useSurface();
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('text-button')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(StyledTextButton, _extends({
    ref: buttonRef
  }, getDataTaktAttributes(), rest, {
    $loading: loading
  }, loading && {
    'aria-live': 'assertive'
  }, loading && {
    'aria-disabled': true
  }, {
    onClick: loading ? undefined : onClick,
    size: size,
    disabled: disabled,
    type: type,
    $variant: isInverted ? 'inverted' : variant
  }), loading && /*#__PURE__*/React__default.createElement(StyledLoadingIcon, null), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loading && loadingLabel ? loadingLabel : children)));
};

export { TextButton as T };
//# sourceMappingURL=TextButton-Ca8KdYfe.js.map
